export enum WidgetDataType {
  HighRiskItems = 0,
  RiskDistribution = 1,
  OverdueMitigations = 2,
  MitigationsDue = 3,
  MitigationsDueByMonth = 4,
  CompletedReports = 5,
  AssetCount = 6,
  PlannedMaintenanceImprovements = 7,
  PlannedMaintenanceDistribution = 8,
}
